import ScrollClass from '../shared/scrolling_class'

const tabs = '.category-seating-chart .group-tabs a'

$.tableRowsList = categoryName =>
  $(`[data-category-names*='${categoryName}']`).filter(function() {
    return $(this).data('categoryNames').indexOf(categoryName) > -1
  })


$.changeTableColors = function() {
  $('.replaceable-table tr').removeClass('row-color')
  $('.replaceable-table tr').not('.hidden').filter(':even').addClass('row-color')
}

function urlParam(name) {
  const results = new RegExp(`[\\?&]${name}=([^&#]*)`).exec(window.location.href)
  if (results) { return decodeURIComponent(results[1]) }
}

function updateImages(categoryName) {
  const image = $(`[data-image-group*='${categoryName}']`).filter(function() {
    return $(this).data('imageGroup').indexOf(categoryName) > -1
  })

  if ($(image)[0]) {
    $('.tab-content .tab-pane').removeClass('active')
    $(image).addClass('active')
  }
}

function updateTable(categoryName, scrollClass) {
  $('.ticket-package-table').addClass('hidden')
  $('.replaceable-table tr').addClass('hidden')

  updateImages(categoryName)

  if ($.tableRowsList(categoryName)[0]) {
    $('.ticket-package-table').removeClass('hidden')
    ScrollClass.scrollToClass(scrollClass)
    $.tableRowsList(categoryName).removeClass('hidden')
    $.changeTableColors()
  }
}

$(window)
  .on('load', function() {
    if ($('.product-item').length > 0){
      var currentOffset = []
      document.querySelectorAll('.ticket-table-head').forEach( (elem, index) => {
        currentOffset.push(elem.offsetTop)
        document.addEventListener('scroll', () => {
          var scrollLength = ($(window).scrollTop())
          if (scrollLength + 70 >= currentOffset[index]) {
            $(elem).next('div').css({'margin-top': $('.ticket-table-head').height()})
            $(elem).css({position: 'fixed', top: '70px', width: $(elem).width(),
              display: 'block'})

            if(index) {
              const prevElem = $('.ticket-table-head')[index - 1]
              $(prevElem).css({ display: 'none'})
            }
          } else {
            $(elem).css({position: 'relative', top: '0px', width: '100%', display: 'block'})
            $(elem).next('div').css({'margin-top': 0})
          }
        }, 0)
      })
    }
  })

  


$(document)
  .on('turbolinks:load', function() {
    $('.category-seating-chart .ticket-package-table, .category-seating-chart .replaceable-table tr')
      .addClass('hidden')

    const category = urlParam('package-group') ||
      $('.category-seating-chart .group-tabs .active').data('categoryName')

    if (category) { updateTable(category, 'scroll-on-page-load') }
  })
  .on('click', tabs, function() {
    updateTable($(this).data('categoryName'), 'scroll-on-click')
  })
  .on('click', '.minus', function() {
    var $input = $(this).parent().find('input')
    var count = parseInt($input.val()) - 1
    count = count < 1 ? 1 : count
    $input.val(count)
    $input.change()
  })
  .on('click', '.plus', function() {
    var $input = $(this).parent().find('input')
    $input.val(parseInt($input.val()) + 1)
    $input.change()
    return false
  })

export {urlParam}
